var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('a',{class:{'link_in_tb_':_vm.templateArgs.related,'link_in_tb':!_vm.templateArgs.related},staticStyle:{"cursor":"pointer !important"},on:{"click":_vm.onClickLink}},[_vm._v(_vm._s(_vm.templateArgs.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }